import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const LdapIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 17"
    {...props}
  >
      <g fillRule="evenodd" stroke="none" strokeWidth="1">
          <g fillRule="nonzero">
              <path
                d="M21 0v16.8L3.15 15.75v-4.725h1.575v3.15l14.7 1.05V1.575l-14.7 1.05v3.15H3.15V1.05L21 0zM10.427 11.582l2.469-2.313H0V7.576h12.896l-2.469-2.31.968-1.066 4.182 4.202-4.127 4.203-1.023-1.023z"></path>
          </g>
      </g>
  </SvgIcon>
);
